var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowStartPage = function SvgArrowStartPage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 91.8 71.8",
    style: {
      enableBackground: "new 0 0 91.8 71.8"
    },
    xmlSpace: "preserve",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#076EFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.3,30.4L61.9,3.2C58.9,0,53.8-0.1,50.6,3c-1.6,1.6-2.4,3.7-2.4,5.7c0,2,0.8,4,2.3,5.6l13.2,13.6L8.8,27.9 c0,0,0,0,0,0c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8l54.9,0.1L50.5,57.5c-1.5,1.6-2.3,3.6-2.3,5.6c0,2.1,0.8,4.2,2.4,5.7 c1.6,1.5,3.6,2.3,5.6,2.3c2.1,0,4.2-0.8,5.7-2.4l26-26.8c0.1-0.1,0.1-0.1,0.2-0.2c1.6-1.6,2.4-3.7,2.4-5.7 C90.5,33.9,89.8,31.9,88.3,30.4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowStartPage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_start_page.941ee1395f8d4aa39d23adc1b89db6fb.svg";